"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingPeriodEnum = void 0;
var BillingPeriodEnum;
(function (BillingPeriodEnum) {
    BillingPeriodEnum[BillingPeriodEnum["MONTHLY"] = 0] = "MONTHLY";
    BillingPeriodEnum[BillingPeriodEnum["QUARTERLY"] = 1] = "QUARTERLY";
    BillingPeriodEnum[BillingPeriodEnum["YEARLY"] = 2] = "YEARLY";
})(BillingPeriodEnum || (exports.BillingPeriodEnum = BillingPeriodEnum = {}));
